import request from "@/utils/request";

export function getHalfPickOrderInfo(params) {
  return request({
    url: `half/pick/getOrderInfo`,
    method: "GET",
    headers: {
      loading: false,
    },
    params,
  });
}
export function submitHalfPickConfirm(data) {
  return request({
    url: "/half/pick/confirm",
    method: "post",
    headers: {
      needToken: true,
      loading: false,
    },
    data,
  });
}